/**
 * Teams channel of Team Stellar, the team owning the Admin Panel.
 *
 * Admins are pointed here whenever something goes wrong that they cannot fix themselves
 * and that needs to be picked up by the team right away.
 */
export const TEAM_STELLAR_CHANNEL_URL =
  "https://teams.microsoft.com/l/channel/19%3AJzPoHlRlqfDvHOSVRtEHRNOCDw4H_E_qUDj3AJNiut41%40thread.tacv2/General?groupId=8887edbc-6b06-4e2d-ad6e-e65b6750fd13&tenantId=31a88536-e2ab-44b5-837e-5110158247ab";
